// Rolla staff profiles automatically added as internal admins on every new team — front-door
// self-serve signups (SignupPage) and admin-created demo accounts (AddAccountModal) — so
// support/CS always has access without needing a separate invite.
export const INTERNAL_ADMIN_PROFILE_IDS = ['RJi61LNt07hkIX5KLRJJXPvOWR82', 'TinAdBpexGcGynPPNAMF9Ms9b9h2']
